import { ServerDeploymentBillInfo } from '@/api/type-server.ts'

export class DeploymentBill {
  instResID: string
  instStatus: number
  createTime: {
    seconds: number
    nanos: number
  }
  finishTime?: {
    seconds?: number
    nanos?: number
  }
  priceCent: number
  costCent: number
  runningDurationSec: number

  constructor(props: ServerDeploymentBillInfo) {
    this.instResID = props.instResID
    this.instStatus = props.instStatus
    this.createTime = {
      seconds: props.createTime.seconds,
      nanos: props.createTime.nanos,
    }
    this.finishTime = {
      seconds: props.finishTime?.seconds,
      nanos: props.finishTime?.nanos,
    }
    this.priceCent = props.priceCent
    this.costCent = props.costCent
    this.runningDurationSec = props.runningDurationSec
  }
}
